import CrossIcon from '../icons/CrossIcon';
import CurrentLocationComponent from '../CurrentLocation';
import CustomSearchIcon from '../icons/SearchIcon';
import LocationAutocompleteComponent from '../autocomplete/LocationAutocomplete';
import { BodyGrey, BodyLarge } from '../Typography';
import { Box, Modal as MUIModal, styled } from '@mui/material';
import { palette } from '../../theme/palette';

export const Root = styled(Box)``;

export const Modal = styled(MUIModal)`
  margin: 10px;
`;

export const ModalContent = styled(Box)`
  margin: auto;
  margin-top: 108px;
  // Specifying a fixed top margin to prevent the modal from bouncing vertically
  // Refer: https://app.shortcut.com/equipmentshare/story/340832/fix-the-location-modal-that-gets-opened-up-when-the-user-clicks-on-the-select-location-to-see-prices-under-the-equipment
  width: 90vw;
  max-width: 400px;
  max-height: 90vh;
  background-color: white;
  border: none;
  box-shadow:
    0px 8px 15px 0px rgba(0, 0, 0, 0.1),
    0px -8px 15px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 30px;
  :focus-visible {
    outline: 0;
  }
  overflow-y: auto;
`;

export const LocationAutocomplete = styled(LocationAutocompleteComponent)`
  border-radius: 5px;
  border: 1px solid ${palette.custom.grey};
  .autocomplete-dropdown {
    padding: 0 10px 0 10px;
  }
  .autocomplete-dropdown-item {
    padding: 0;
    transition: padding 0.4s ease-in-out;
  }
  .autocomplete-dropdown-item:hover {
    padding: 0 10px 0 10px;
    transition: padding 0.4s ease-in-out;
  }
`;

export const SearchIcon = styled(CustomSearchIcon)`
  color: #757575;
  width: 16px;
`;

export const CurrentLocation = styled(CurrentLocationComponent)`
  width: 100%;
  border-radius: 5px;
  border: 1px solid;
  background: white;
  height: 40px;
  margin-top: 14px;
`;

export const LocationLabel = styled(BodyLarge)`
  margin-bottom: 6px;
`;

export const HelperText = styled(BodyGrey, {
  shouldForwardProp: (prop) => prop !== 'hasError',
})<{
  hasError?: boolean;
}>`
  color: ${(props) => (props.hasError ? palette.error.main : palette.custom.mediumGrey)};
  margin-top: 4px;
  margin-left: 2px;
`;

export const CloseButton = styled(Box)`
  cursor: pointer;
  position: absolute;
  top: 122px;
  right: calc(50% - 186px);
  color: ${palette.primary.main};
`;

export const CloseIcon = styled(CrossIcon)`
  color: ${palette.custom.grey};
  width: 21px;
  height: 21px;
  object-fit: contain;
`;
